// extracted by mini-css-extract-plugin
module.exports = {"section":"nft-withdrawal_section__utsNs","inner":"nft-withdrawal_inner__VWHqK","title":"nft-withdrawal_title__t0COK","text":"nft-withdrawal_text__TC5zx"};